import React from 'react';

class AttachmentDownload extends React.Component {

  static propTypes = {
    src: React.PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.downloadDocument();
    window.addEventListener('resize', this.onResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize, false);
  }

  downloadDocument = () => {
    document.querySelector('.download').click();
  };

  render() {
    const {
      fileName,
      src, // eslint-disable-line no-unused-vars
      ...other
    } = this.props;
    return (
      <div {...other}>
        <div>
          Votre document va être téléchargé automatiquement. Si le téléchargement n'a pas commencé
          au bout de quelques secondes, cliquez ici :
          <a className="download" href={src} download={fileName}> {fileName} </a>
        </div>
      </div>
    );
  }
}

export default AttachmentDownload;



// WEBPACK FOOTER //
// ./book/src/attachmentDownload/AttachmentDownload.jsx